module.exports = __webpack_public_path__ + "static/assets/da36f619bf5e83149b979a94244662f7.svg";